import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { ConnectedAccount } from './connected-account.entity';
export class CreateConnectedAccountDto extends Omit(
    ConnectedAccount,
    [...BaseEntityFieldsArray, 'providerType', 'providerId'],
    ['seller', 'providerType', 'providerId'],
) {
    seller?: string;
}
